import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setCookies } from '../hooks/useCookies';
import { ADMIN_AUTH_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const login = 'login';
export const logIn = createAsyncThunk('api/logIn', async (data, { rejectWithValue }) => {
  const body = { email: data.email, password: data.Password };
  try {
    const response = await axios.post(`${ADMIN_AUTH_URL}/${login}`, body, { headers });
    if (response.status === 200 && response.data.success && response.data.code === 200) {
      setCookies('Token', response.data.data.user.auth_token);
      setCookies('refreshToken', response.data.data.user.refresh_token);
      setCookies('USERID', response.data.data.user.user_id);
      setCookies('USERNAME', response.data.data.user.name);
      setCookies('USEREMAIL', response.data.data.user.email);
      setCookies('THEME', 'false');
      return response.data;
    }
    // If response is 200 but success is false, treat as error
    const errorMessage = response.data?.message || 'Login failed';
    return rejectWithValue({ message: errorMessage });
  } catch (error) {
    // Return proper error structure without setting cookies
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.data?.message ||
      error.message ||
      'Login failed';
    return rejectWithValue({ message: errorMessage });
  }
});

const loginSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    loginData: {},
    error: '',
  },
  extraReducers: {
    [logIn.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [logIn.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginData = action.payload;
    },
    [logIn.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default loginSlice.reducer;
